'use-client';
import * as React from 'react';
import type {
  StripColumnsContainerProps,
  IStripColumnContainerImperativeActions,
} from '../../../StripColumnsContainer.types';
import StripColumnContainer from '../../StripColumnsContainer';
import styles from './DesignedStrip.scss';

const DefaultStripContainer: React.ForwardRefRenderFunction<
  IStripColumnContainerImperativeActions,
  StripColumnsContainerProps
> = (props, ref) => {
  const fillLayers = {
    ...(props.fillLayers || {}),
    extraClass: `${styles.root}`,
  };

  return (
    <StripColumnContainer ref={ref as any} {...props} fillLayers={fillLayers} />
  );
};

export default React.forwardRef(DefaultStripContainer);
